import React from 'react'

const Icon: React.FC<any> = ({ ...props }) => {
  return (
    <svg viewBox="0 0 24px 24px" {...props}>
      <circle />
      <path d="M9.00003 16.17L4.83003 12L3.41003 13.41L9.00003 19L21 7L19.59 5.59L9.00003 16.17Z" />
    </svg>
  )
}

export default Icon
